<template>
  <SidebarLayout>
    <!-- Sidebar -->
    <template v-slot:sidebar="{ sidebar }">
      <div class="d-flex flex-column my-4">
        <v-btn v-for="item in menu" :key="item.tab" text :block="sidebar" @click="tab = item.tab" :icon="!sidebar" color="white" :title="item.title" :class="['mb-4', sidebar ? 'left-align-btn' : 'mx-auto']">
          <v-icon :left="sidebar">{{ item.icon }}</v-icon> <span v-if="sidebar">{{ item.title }}</span>
        </v-btn>
      </div>
    </template>
    <!-- Main -->
    <template v-slot:main>
      <IdeaCreator v-if="tab === 0" />
      <IdeaPreview v-if="tab === 1" />
      <IdeaBrainstorm v-if="tab === 2" />
      <IdeaConcept v-if="tab === 3" />
      <IdeaSettings v-if="tab === 4" />
    </template>
  </SidebarLayout>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase/init'

import SidebarLayout from '@/layouts/Sidebar.vue';
import IdeaCreator from '@/components/ideas/IdeaCreator.vue';
import IdeaPreview from '@/components/ideas/IdeaPreview.vue';
import IdeaBrainstorm from '@/components/ideas/IdeaBrainstorm.vue';
import IdeaConcept from '@/components/ideas/IdeaConcept.vue';
import IdeaSettings from '@/components/ideas/IdeaSettings.vue';
// import IdeaSparky from '@/components/ideas/IdeaSparky.vue';

export default {
  name: 'RealmIdea',
  
  components: {
    SidebarLayout,
    IdeaCreator,
    IdeaPreview,
    IdeaBrainstorm,
    IdeaConcept,
    IdeaSettings,
  },

  data() {
    return {
      tab: 0,
      idea: null,
      loading: false,
      sparkyCollapsed: false,
      menu: [
        { title: 'Creator', icon: 'mdi-creation', tab: 0 },
        { title: 'Preview', icon: 'mdi-controller', tab: 1 },
        { title: 'Brainstorm', icon: 'mdi-brain', tab: 2 },
        { title: 'Concept', icon: 'mdi-lightbulb', tab: 3 },
        { title: 'Settings', icon: 'mdi-cog-outline', tab: 4 },
      ],
    }
  },

  methods: {
    intitialize() {
      this.loading = true;
      let ideaId = this.$route.params.id;
      if (ideaId) {
        this.loadIdea(ideaId);
      } else {
        this.loading = false;
        // Or handle creation of a new idea if that's a possible use case
        console.log("No idea ID found in route params.");
      }
    },

    loadIdea(ideaId) {
      const ideaRef = doc(db, 'ideas', ideaId);
      getDoc(ideaRef).then((doc) => {
        if (doc.exists()) {
          this.idea = { id: doc.id, ...doc.data() };
        } else {
          console.error("No such idea document!");
          this.idea = null;
        }
        this.loading = false;
      }).catch(error => {
        console.error("Error getting document:", error);
        this.loading = false;
      });
    },

    saveIdea() {
      console.log('TODO: implement save for idea', this.idea?.id)
    },
  },

  mounted() {
    this.intitialize()
  }
}
</script>
